import {
  Box,
  Button,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Hidden,
} from "@mui/material";
import { IoLogInOutline, IoLogOutOutline } from "react-icons/io5";
import { RiAccountCircleFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AuthRepository } from "../repositories/AuthRepository";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { GoDotFill } from "react-icons/go";
import { TbArrowsExchange } from "react-icons/tb";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/mk";
import { setMenuOpen } from "../../store/MenuSlice";
import { TbMenu2 } from "react-icons/tb";

dayjs.extend(relativeTime);
dayjs.locale("mk");

export default function LoginHeader() {
  const theme = useTheme();
  const auth = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [loadingMore, setLoadingMore] = useState(false);
  const dispatch = useDispatch();
  const menu = useSelector((state) => state.menu);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: { md: "flex-end", xs: "space-between" },
        overflowX: "hidden",
        overflowY: "hidden",
        width: "100%",
        zIndex: 1,
        overflowX: "hidden",
        maxWidth: "100%",
        boxSizing: "border-box",
        padding: { xs: "5px 5px", md: "5px 20px" },
        backgroundColor: "#f2f9ff",
        gap: 3,
      }}
    >
      <Hidden mdUp>
        <IconButton onClick={() => dispatch(setMenuOpen(!menu.open))}>
          <TbMenu2 />
        </IconButton>
      </Hidden>
      {auth?.userData ? (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: theme.palette.secondary.main,
            }}
          >
            <RiAccountCircleFill fontSize={22} color="#969696" />
            <Typography
              noWrap
              sx={{ fontSize: "14px", fontFamily: "Inter-Regular" }}
            >
              {auth.userData.firstname + " " + auth.userData.lastname}
            </Typography>
          </Box>
          <Button
            variant="transparent"
            onClick={() => {
              navigate("/login");
              AuthRepository.logout();
            }}
          >
            <IoLogOutOutline size={24} color={theme.palette.secondary.main} />
            <Typography
              variant="caption"
              sx={{
                fontSize: "14px",
                fontFamily: "Inter-Regular",
                marginLeft: "2px",
                color: theme.palette.secondary.main,
              }}
            >
              Одјава
            </Typography>
          </Button>
        </>
      ) : (
        <Button variant="transparent" onClick={() => navigate("/login")}>
          <IoLogInOutline size={24} color={theme.palette.secondary.main} />
          <Typography
            variant="caption"
            sx={{
              fontSize: "14px",
              fontFamily: "Inter-Regular",
              marginLeft: "2px",
              color: theme.palette.secondary.main,
            }}
          >
            Најава
          </Typography>
        </Button>
      )}
    </Box>
  );
}
